import { render, staticRenderFns } from "./QuillVideoDialog.vue?vue&type=template&id=c6d08274&scoped=true&"
import script from "./QuillVideoDialog.vue?vue&type=script&lang=js&"
export * from "./QuillVideoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d08274",
  null
  
)

export default component.exports